<h1 id="greeting">Welcome, {{name}}!</h1>
<p>
  <ng-container [ngTemplateOutlet]="!!schoolYear ? WelcomeSchoolYear : NoSchoolYear">
  </ng-container>
  <ng-template #WelcomeSchoolYear>
    You have activated licenses for the <span [innerHTML]="schoolYearDisplay"></span> school year.
    We hope you have a wonderful year!
  </ng-template>
  <ng-template #NoSchoolYear>
    You do not have any activated licenses.
  </ng-template>
</p>

